import React from 'react';
import PropTypes from 'prop-types';

// import { Bert } from 'meteor/themeteorchef:bert';
import { isEmpty } from 'lodash';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import {
  Box,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@mui/material';
// import ExpandLessIcon from '@mui/icons-material/ExpandLess';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import PlagiarismOutlinedIcon from '@mui/icons-material/PlagiarismOutlined';
import SaveIcon from '@mui/icons-material/Save';
import ShareIcon from '@mui/icons-material/Share';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LIBRARY_ICON_TYPES } from '../../../api/AnnotationTemplates/AnnotationTemplates';
import Videos from '../../../api/Videos/Videos';
import Loading from '../../components/Loading';
import ShowListIconsFontawesome from '../../components/ShowListIconsFontawesome';

const MapsAdvancedTableAnnotationsField = props => {
  const {
    listComponentsAdvanced,
    loading,
    videoList,
    setListComponentsAdvanced,
    setSettingsAdvanced,
    settingsAdvanced
  } = props;
  if (loading) return <Loading />;
  const [localSettings, setLocalSettings] = React.useState(settingsAdvanced.tableAnnotations);
  const [iconFontawesome, setIconFontawesome] = React.useState(
    listComponentsAdvanced.TableAnnotationsComponent.iconFontawesome
  );
  const [openModal, setOpenModal] = React.useState(false);

  const [iconSvg, setIconSvg] = React.useState(
    listComponentsAdvanced.TableAnnotationsComponent.iconSvg
  );
  const [nameComponent, setNameComponent] = React.useState(
    listComponentsAdvanced.TableAnnotationsComponent.name
  );
  const [libraryIcon, setLibraryIcon] = React.useState(
    listComponentsAdvanced.TableAnnotationsComponent.libraryIcon
  );
  const [videoSelect, setVideoSelect] = React.useState(
    videoList.find(video => video._id === localSettings.videoId) || {}
  );

  const [templateSelected, setTemplateSelected] = React.useState(
    () =>
      (videoSelect &&
        videoSelect.annotationTemplates?.find(
          template => template._id === localSettings.templateId
        )) ||
      {}
  );
  const handleVideoChange = event => {
    const selectedVideoId = event.target.value;
    const selectedVideo = videoList.find(video => video._id === selectedVideoId) || {};
    setVideoSelect(selectedVideo);
    setTemplateSelected({});
    setLocalSettings({ ...localSettings, videoId: selectedVideoId, templateId: '' });
    setSettingsAdvanced(prev => ({
      ...prev,
      tableAnnotations: { ...localSettings, videoId: selectedVideoId, templateId: '' }
    }));
  };

  const handleTemplateChange = event => {
    const selectedTemplateId = event.target.value;
    const selectedTemplate =
      videoSelect?.annotationTemplates?.find(template => template._id === selectedTemplateId) || {};
    setTemplateSelected(selectedTemplate);
    setLocalSettings({ ...localSettings, templateId: selectedTemplateId });
    setSettingsAdvanced(prev => ({
      ...prev,
      tableAnnotations: { ...localSettings, templateId: selectedTemplateId }
    }));
  };

  const handleIconSelected = (elementIcon, library) => {
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      setIconFontawesome(elementIcon);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        TableAnnotationsComponent: {
          name: listComponentsAdvanced.TableAnnotationsComponent.name,
          show: listComponentsAdvanced.TableAnnotationsComponent.show,
          iconFontawesome: elementIcon,
          libraryIcon: library
        }
      });
    }

    if (library === LIBRARY_ICON_TYPES.SVG) {
      setIconSvg(elementIcon.url);
      setIconFontawesome(elementIcon.name);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        TableAnnotationsComponent: {
          name: listComponentsAdvanced.TableAnnotationsComponent.name,
          show: listComponentsAdvanced.TableAnnotationsComponent.show,
          iconFontawesome: elementIcon.name,
          iconSvg: elementIcon.url,
          libraryIcon: library,
          cetegorySvg: elementIcon.category
        }
      });
    }
    setLibraryIcon(library);
  };

  return (
    <Box display="flex" width="100%" gab={1} justifyContent="space-around">
      <Box display="column" width="40%" gab={1}>
        <Box
          component="form"
          sx={{
            display: 'flex',
            mb: 2,
            width: '100%'
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-required"
            label="Nombre del componente"
            size="small"
            value={nameComponent}
            onChange={event => setNameComponent(event.target.value)}
            mb={2}
            fullWidth
          />
          <IconButton
            onClick={() => setOpenModal(true)}
            style={{
              color: '#2A3F90'
            }}
          >
            {!isEmpty(libraryIcon) ? (
              <>
                {libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME && (
                  <FontAwesomeIcon icon={iconFontawesome} />
                )}
                {libraryIcon === LIBRARY_ICON_TYPES.SVG && (
                  <img
                    src={iconSvg}
                    alt={iconFontawesome}
                    style={{ marginRight: '5px', width: '20px', height: '20px' }}
                  />
                )}
              </>
            ) : (
              <ShareIcon />
            )}
          </IconButton>
          <IconButton
            onClick={() =>
              setListComponentsAdvanced({
                ...listComponentsAdvanced,
                TableAnnotationsComponent: {
                  name: nameComponent,
                  show: listComponentsAdvanced.TableAnnotationsComponent.show
                }
              })
            }
            style={{
              color: '#2A3F90'
            }}
          >
            <SaveIcon />
          </IconButton>
          <ShowListIconsFontawesome
            openModal={openModal}
            setOpenModal={setOpenModal}
            handleIconSelected={handleIconSelected}
            selectedIcon={listComponentsAdvanced.TableAnnotationsComponent.iconFontawesome}
            startLibrary={listComponentsAdvanced.TableAnnotationsComponent.libraryIcon}
            svg={listComponentsAdvanced.TableAnnotationsComponent.iconSvg}
            startCategorySvg={listComponentsAdvanced.TableAnnotationsComponent.cetegorySvg}
          />
        </Box>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="video-select-label">Video</InputLabel>
          <Select
            labelId="video-select-label"
            value={localSettings.videoId || ''}
            onChange={handleVideoChange}
            label="Video"
            size="small"
          >
            {videoList.map(video => (
              <MenuItem key={video._id} value={video._id}>
                {video.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {!isEmpty(localSettings.videoId) && (
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="template-select-label">Template</InputLabel>
            <Select
              labelId="template-select-label"
              value={localSettings.templateId || ''}
              onChange={handleTemplateChange}
              label="Template"
              size="small"
            >
              {videoSelect.annotationTemplates?.map(template => (
                <MenuItem key={template._id} value={template._id}>
                  {template.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        {!isEmpty(localSettings.videoId) && !isEmpty(localSettings.templateId) && (
          <FormControl fullWidth>
            <InputLabel id="demo-select-label">Element</InputLabel>
            <Select
              labelId="demo-select-label"
              id="demo-select"
              label="Element"
              size="small"
              value={localSettings.orderElement || ''}
              onChange={e => {
                setLocalSettings({
                  ...localSettings,
                  orderElement: e.target.value
                });
                setSettingsAdvanced(prev => ({
                  ...prev,
                  tableAnnotations: {
                    ...prev.tableAnnotations,
                    orderElement: e.target.value
                  }
                }));
              }}
            >
              {templateSelected.elements
                .filter(item => item.elementType === 'select') // Filtrar por elementType
                .map(item => (
                  <MenuItem key={item.order} value={item.order}>
                    {item.labelName}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        )}
      </Box>
      <Box display="column" width="40%" gab={1} />
    </Box>
  );
};

export default withTracker(() => {
  const videosSub = Meteor.subscribe('videos.maps');
  const loading = !videosSub.ready();
  const videoList = Videos.find({}, { sort: { name: 1 } }).fetch();
  return {
    loading,
    videoList
  };
})(MapsAdvancedTableAnnotationsField);

MapsAdvancedTableAnnotationsField.defaultProps = {
  setListComponentsAdvanced: () => {},
  loading: false
};
MapsAdvancedTableAnnotationsField.propTypes = {
  listComponentsAdvanced: PropTypes.object.isRequired,
  setListComponentsAdvanced: PropTypes.func,
  videoList: PropTypes.array.isRequired,
  settingsAdvanced: PropTypes.object.isRequired,
  setSettingsAdvanced: PropTypes.func.isRequired,
  loading: PropTypes.bool
};
